import { GenesysCloudQueue } from '../../../common/store/genesys-cloud/queues/models/genesys-cloud-queue.model';
import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { tap, switchMap } from 'rxjs/operators';
import { QueueApiService } from '../../../common/store/genesys-cloud/queues/services/queue-api.service';
import { Observable } from 'rxjs';

export interface EmailModalState {
  queues: GenesysCloudQueue[];
  loading: boolean;
  createConversationFailed: boolean;
}

export const initialState: EmailModalState = {
  queues: [],
  loading: false,
  createConversationFailed: false
};

@Injectable()
export class GenesysProactiveEmailModalStore extends ComponentStore<EmailModalState> {
  constructor(private readonly api: QueueApiService) {
    super(initialState);
    this.loadQueues();
  }

  readonly getAllParams = {
    pageNumber: 1,
    pageSize: 500
  };

  setLoading(loadingState: boolean): void{
    this.patchState({ loading: loadingState });
  }

  setConversationFailed(createFailed: boolean): void{
    this.patchState({ createConversationFailed: createFailed });
  }

  private setQueues(queues: GenesysCloudQueue[]): void{
    this.patchState({ queues });
  }

  readonly loadQueues = this.effect((action: Observable<void>) =>
    action.pipe(
      switchMap(() =>
        this.api.getAllQueues$(this.getAllParams.pageSize, this.getAllParams.pageNumber).pipe(
          tap((qsr) => this.setQueues(qsr.entities))
        )
      )
    )
  );

  readonly queues$ = this.select(state => state.queues);

  readonly loading$ = this.select(state => state.loading);
  readonly createConversationFailed$ = this.select(state => state.createConversationFailed);
}
